import Head from "next/head"
import DefaultLayout from "@/components/DefaultLayout"
import SliderBarLeft from "@/components/SliderBarLeft"
import SliderBarRight from "@/components/SliderBarRight"
import TabBar from "@/components/TabBar"
import styles from "@/styles/article/deliveryBrand.module.scss"
import { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import Image from 'next/image'
import Link from 'next/link'

import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()
const imageDomain = publicRuntimeConfig.imageDomain

export default function DeliveryBrand() {
  const [activeTab, setActiveTab] = useState(0)
  const tabList = [
    { id: 1, name: 'Tracking your package' },
    { id: 2, name: 'Shipping' },
    { id: 3, name: 'Scheduling Delivery' }
  ]
  // 切换tab，展示不同的内容
  const handleTabChange = (index: number) => {
    setActiveTab(index)
  }

  const router = useRouter()
  useEffect(() => {
    const { activeTab }: any = router.query

    // activeTab初始化赋值
    if (activeTab) {
      // 判断参数是否合规，合规参数才进行tab赋值
      let target = tabList.filter((item: any, index: number) => index == Number(activeTab))

      if (target.length) handleTabChange(Number(activeTab))
    }
  }, [router.query])


  return (
    <>
      <Head>
        <title>
          Online Shopping Australia - Beauty & Health, Computers, Toys, - Deals & Discounts | CrazySales
        </title>
        <meta
          name="keywords"
          content="Online Shopping Australia, online shopping sites, Home Shopping, Shopping Deals, Best Deals, Home Garden, Pet Supplies, Sports Fitness, Bedding Bath, Buy Online, Discount Shopping, Toys Hobbies, Beauty Health, Crazy Sales, Computers, IT, Christmas, Electronics, Automotive, Tools, Appliances, Baby, CrazySales"
        ></meta>
        <meta
          name="description"
          content="CrazySales.com.au - Australia's #1 online shopping website! Cheap bargains &amp; discounts with the top online shopping Australia store! From furniture, to toys &amp; hobbies, to appliances &amp; pet supplies -- we've got it all, with free shipping on selected items!"
        ></meta>
      </Head>

      <DefaultLayout>
        <div className={`${styles['page-delivery-brand']} slider-wapper`}>
          <SliderBarLeft></SliderBarLeft>
          <SliderBarRight></SliderBarRight>

          {/* banner图 */}
          <Image
            className={styles['delivery-banner']}
            src={`${imageDomain}/delivery-brand/delivery-banner.png`}
            alt={'male'}
            width={1200}
            height={135}
          ></Image>

          <div className={styles['delivery-content']}>
            <TabBar 
              tabList={tabList}
              activeTab={activeTab}
              onTabChange={handleTabChange}
            />

            {
              activeTab === 0 && 
              <div className={styles['tab-one']}>
                <div className={styles['ask-title']}>How to Track Your Order?</div>
                <div className={styles['ask-title']}>Follow the steps below to check the progress of your parcel delivery.</div>

                <div className={`${styles['content-title-box']} margin-top-24`}>
                  <div className={styles['content-point']}>1</div>
                  <div className={styles['title-text']}>
                    Log in to your account and click “Track My Order” at the top of the home page, or click “View Orders” in the dropdown menu under ‘My Account’ to enter the order list.
                  </div>
                </div>

                <div className={styles['content-img-box']}>
                  <Image
                    className={styles['content-img']}
                    src={`${imageDomain}/delivery-brand/delivery-content-p1.png`}
                    alt={'delivery'}
                    width={568}
                    height={240}
                  ></Image>
                  <Image
                    className={styles['content-img']}
                    src={`${imageDomain}/delivery-brand/delivery-content-p2.png`}
                    alt={'delivery'}
                    width={568}
                    height={240}
                  ></Image>
                </div>

                <div className={`${styles['content-title-box']} margin-top-32`}>
                  <div className={styles['content-point']}>2</div>
                  <div className={styles['title-text']}>
                    After you are in the order list, find the order you want to check the logistics, and click “Track Order”, or click “View Detail” to go to the order details, and then click “Track Order”.
                  </div>
                </div>

                <div className={styles['content-img-box']}>
                  <Image
                    className={styles['content-img']}
                    src={`${imageDomain}/delivery-brand/delivery-content-p3.png`}
                    alt={'delivery'}
                    width={568}
                    height={296}
                  ></Image>
                  <Image
                    className={styles['content-img']}
                    src={`${imageDomain}/delivery-brand/delivery-content-p4.png`}
                    alt={'delivery'}
                    width={568}
                    height={296}
                  ></Image>
                </div>

                <div className={`${styles['content-title-box']} margin-top-32`}>
                  <div className={styles['content-point']}>3</div>
                  <div className={styles['title-text']}>
                    Copy the shipment number and click on the link at the bottom to check the delivery progress on the courier service website.
                  </div>
                </div>

                <div className={styles['content-img-box']}>
                  <Image
                    className={styles['content-img-big']}
                    src={`${imageDomain}/delivery-brand/delivery-content-p5.png`}
                    alt={'delivery'}
                    width={927}
                    height={473}
                  ></Image>
                </div>

                <div className={`${styles['ask-title']} padding-top-24`}>Courier Service website</div>

                <div className={styles['answer-desc']}>
                  You can follow the steps above to check the delivery progress of your parcel, or select the tracking link for the courier company below to check (please make sure you have received the tracking number/logistics order number), or call the courier company to check.
                </div>

                <div className={styles['tips-text']}>
                  *Please make sure you have your tracking number handy before you click the tracking link.
                </div>


                <div className={styles['status-table']}>
                  <div className={styles['status-table-header']}>
                    <div className={styles['header-item']}>Courier Name</div>
                    <div className={styles['header-item']}>Tracking Link</div>
                    <div className={styles['header-item']}>Courier Phone Number</div>
                  </div>

                  <div className={styles['status-table-content']}>
                    <div className={styles['content-item']}>eParcel<br/>eParcel Express</div>
                    <div className={styles['content-item']}>
                      <Link
                        href="https://auspost.com.au/mypost/track/#/search"
                        legacyBehavior
                      >
                        <a className={styles['link']} rel="noopener noreferrer">
                          https://auspost.com.au/mypost/track/#/search
                        </a>
                      </Link>
                    </div>
                    <div className={styles['content-item']}>
                      13 POST (13 7678)<br/>
                      <span style={{ fontSize: '0.8rem' }}>
                        8am–6pm, Monday–Friday (except national public holidays).
                      </span>
                    </div>
                  </div>

                  <div className={styles['status-table-content']}>
                    <div className={styles['content-item']}>Aramex<br/>Fastway</div>
                    <div className={styles['content-item']}>
                      <Link
                        href="https://www.aramex.com.au/tools/track/"
                        legacyBehavior
                      >
                        <a className={styles['link']} rel="noopener noreferrer">
                          https://www.aramex.com.au/tools/track/
                        </a>
                      </Link>
                    </div>
                    <div className={styles['content-item']}>/</div>
                  </div>

                  <div className={styles['status-table-content']}>
                    <div className={styles['content-item']}>Allied<br/>Allied Express</div>
                    <div className={styles['content-item']}>
                      <Link
                        href="https://www.alliedexpress.com.au/"
                        legacyBehavior
                      >
                        <a className={styles['link']} rel="noopener noreferrer">
                          https://www.alliedexpress.com.au/
                        </a>
                      </Link>
                    </div>
                    <div className={styles['content-item']}>131373</div>
                  </div>

                  <div className={styles['status-table-content']}>
                    <div className={styles['content-item']}>Hunter</div>
                    <div className={styles['content-item']}>
                      <Link
                        href="https://www.hunterexpress.com.au/tracking/"
                        legacyBehavior
                      >
                        <a className={styles['link']} rel="noopener noreferrer">
                          https://www.hunterexpress.com.au/tracking/
                        </a>
                      </Link>
                    </div>
                    <div className={styles['content-item']}>/</div>
                  </div>

                  <div className={styles['status-table-content']}>
                    <div className={styles['content-item']}>Fast House</div>
                    <div className={styles['content-item']}>
                      <Link
                        href="https://au.fh.express/pc/search"
                        legacyBehavior
                      >
                        <a className={styles['link']} rel="noopener noreferrer">
                          https://au.fh.express/pc/search
                        </a>
                      </Link>
                    </div>
                    <div className={styles['content-item']}>/</div>
                  </div>

                  <div className={styles['status-table-content']}>
                    <div className={styles['content-item']}>Sendle</div>
                    <div className={styles['content-item']}>
                      <Link
                        href="https://track.sendle.com/tracking"
                        legacyBehavior
                      >
                        <a className={styles['link']} rel="noopener noreferrer">
                          https://track.sendle.com/tracking
                        </a>
                      </Link>
                    </div>
                    <div className={styles['content-item']}>/</div>
                  </div>

                  <div className={styles['status-table-content']}>
                    <div className={styles['content-item']}>Kinisi</div>
                    <div className={styles['content-item']}>
                      <Link
                        href="https://kinisitransport.com/tracking/"
                        legacyBehavior
                      >
                        <a className={styles['link']} rel="noopener noreferrer">
                          https://kinisiglobal.com/track-shipment/
                        </a>
                      </Link>
                    </div>
                    <div className={styles['content-item']}>
                        +61(0)385934168<br/>
                      <span style={{ fontSize: '0.8rem' }}>
                        We&apos;re available Monday to Friday 9am to 5pm AEST<br/>(except national public holidays).
                      </span>
                    </div>
                  </div>

                  <div className={styles['status-table-content']}>
                    <div className={styles['content-item']}>International Registered Post</div>
                    <div className={styles['content-item']}>
                      <Link
                        href="https://www.aftership.com/track/"
                        legacyBehavior
                      >
                        <a className={styles['link']} rel="noopener noreferrer">
                          https://www.aftership.com/track/
                        </a>
                      </Link>
                    </div>
                    <div className={styles['content-item']}>/</div>
                  </div>

                  <div className={styles['status-table-content']}>
                    <div className={styles['content-item']}>Shippit</div>
                    <div className={styles['content-item']}>
                      <Link
                        href="https://www.shippit.com.sg/track-your-package/"
                        legacyBehavior
                      >
                        <a className={styles['link']} rel="noopener noreferrer">
                          https://www.shippit.com.sg/track-your-package/
                        </a>
                      </Link>
                    </div>
                    <div className={styles['content-item']}>/</div>
                  </div>

                  <div className={styles['status-table-content']}>
                    <div className={styles['content-item']}>CouriersPlease</div>
                    <div className={styles['content-item']}>
                      <Link
                        href="https://www.couriersplease.com.au/tools-track"
                        legacyBehavior
                      >
                        <a className={styles['link']} rel="noopener noreferrer">
                          https://www.couriersplease.com.au/tools-track
                        </a>
                      </Link>
                    </div>
                    <div className={styles['content-item']}>
                      1300 36 1000<br/>
                      <span style={{ fontSize: '0.8rem' }}>
                        8.00 - 5.30 (Local Time),Monday - Friday(Except Public Holidays)
                      </span>
                    </div>
                  </div>

                  <div className={styles['status-table-content']}>
                    <div className={styles['content-item']}>Regular Mail</div>
                    <div className={styles['content-item']}>Using Australia Post&apos;s regular mail delivery service, this option does not include parcel tracking numbers and fixed ETA times. Time varies greatly, even posting multiple parcels to the same delivery address. In normal circumstances, parcels should be received within 2-15 business days of dispatch</div>
                    <div className={styles['content-item']}>/</div>
                  </div>
                </div>
              </div>
            }
            {
              (activeTab === 1) 
              &&
              <div className={styles['tab-two']}>
                <div className={styles['ask-title']}>
                  Depending on your location and the type of goods you have purchased, CrazySales will despatch your goods with one of these courier providers.
                </div>

                <div className={`${styles['content-title-box']} margin-top-20`}>
                  <div className={styles['content-point']}>1</div>
                  <div className={styles['title-text']}>
                    <b>eParcel or Aramex (formerly Fastway Couriers): for items that weigh 22kg or less (Aramex is less than 25kg)</b>
                  </div>
                </div>

                <div className={`padding-16`}>
                  <div className={styles['ask-title']}>· What is eParcel Post?</div>
                  <div className={styles['answer-desc']}>
                    eParcel is Australia Post&apos;s Internet enabled freight system. The delivery status of a package can be checked via the Internet at &nbsp;
                    <Link
                      href="https://auspost.com.au/"
                      legacyBehavior
                    >
                      <a className={styles['link']} rel="noopener noreferrer">
                        https://auspost.com.au/ 
                      </a>
                    </Link>
                    &nbsp;.
                  </div>

                  <div className={styles['ask-title']}>· What is Aramex?</div>
                  <div className={styles['answer-desc']}>
                    Aramex is a third-party courier service provider that also handles freight. The delivery status of a package can be checked via the internet at &nbsp;                  <Link
                      href="https://www.aramex.com.au/"
                      legacyBehavior
                    >
                      <a className={styles['link']} rel="noopener noreferrer">
                        https://www.aramex.com.au/
                      </a>
                    </Link>
                    &nbsp;.
                  </div>

                  <div className={styles['ask-title']}>· How they work?</div>
                  <div className={styles['answer-desc']}>
                    Each parcel carries a barcoded address label, which is scanned at several points during the delivery process.<br/>
                    This will usually happen the evening your parcel is dispatched or early the next day.<br/>
                    Your tracking number is included in your shipping confirmation email.
                  </div>

                </div>

                <div className={`${styles['content-title-box']} margin-top-8`}>
                  <div className={styles['content-point']}>2</div>
                  <div className={styles['title-text']}>
                    <b>Hunter or Allied: for items exceeding 25 kg</b>
                  </div>
                </div>

                <div className={`padding-16`}>
                  <div className={styles['answer-desc']}>
                    Where items exceed 25 kg, they require a more specialised delivery service. Third-party couriers specialise in providing an Australia-wide delivery service for large items. You will receive an email confirmation of your order, including a tracking number, as soon as your goods are dispatched.
                  </div>
                  <div className={`${styles['answer-desc']} padding-top-8`}>
                    Each parcel carries a barcoded address label, which is scanned at several points during the delivery process. Parcels are collected from our warehouse on a daily basis (Monday to Friday). On arrival at the freight depot, they are sorted and scanned into their corresponding states for shipping the next day.
                  </div>
                  <div className={`${styles['answer-desc']} padding-top-8`}>
                    For large item deliveries, our vehicle will be equipped with a hydraulic tailgate, and the driver will use the trolley to ensure that your item can be safely delivered to your door.
                  </div>
                  <div className={`${styles['answer-desc']} padding-top-8`}>
                    According to the third-Party Courier&apos;s delivery policy, the driver is not allowed to carry any items into customers&apos; flats, offices or any other buildings that are located on the upper stairs. Please note that the proposed delivery time is not specified, and an extra charge will be included if a special arrangement for delivery is requested.
                  </div>
                </div>

                <div className={`${styles['content-title-box']} margin-top-8`}>
                  <div className={styles['content-point']}>3</div>
                  <div className={styles['title-text']}>
                    <b>International Registered Post</b>
                  </div>
                </div>

                <div className={`padding-16`}>
                  <div className={styles['answer-desc']}>
                    Where items will come directly from our suppliers outside the Australia which will be shipped directly to you via startrack or UBI. The delivery status of a package can be checked via the internet at &nbsp;
                    <Link
                      href="https://www.aftership.com/track/"
                      legacyBehavior
                    >
                      <a className={styles['link']} rel="noopener noreferrer">
                        https://www.aftership.com/track/
                      </a>
                    </Link>
                    &nbsp;.
                  </div>
                </div>

                <div className={`${styles['content-title-box']} margin-top-8`}>
                  <div className={styles['content-point']}>4</div>
                  <div className={styles['title-text']}>
                    <b>Fast House</b>
                  </div>
                </div>

                <div className={`padding-16`}>
                  <div className={styles['answer-desc']}>
                    This logistics is suitable for parcels weighing less than 5kg and measuring less than 50cm in length and width, and orders with a delivery address in the same city as our shipping warehouse in Melbourne or Sydney.
                  </div>
                </div>

                <div className={`${styles['content-title-box']} margin-top-8`}>
                  <div className={styles['content-point']}>5</div>
                  <div className={styles['title-text']}>
                    <b>Sendle, Shippit, CouriersPlease (for items that weigh 25kg or less)</b>
                  </div>
                </div>

                <div className={`padding-16`}>
                  <div className={styles['ask-title']}>· What is Sendle?</div>
                  <div className={styles['answer-desc']}>
                    Sendle is a registered B Corp and Australia&apos;s first 100% carbon neutral delivery service partnering with South Pole. The delivery status of a package can be checked via the internet at  &nbsp;
                    <Link
                      href="https://track.sendle.com/tracking"
                      legacyBehavior
                    >
                      <a className={styles['link']} rel="noopener noreferrer">
                        https://track.sendle.com/tracking
                      </a>
                    </Link>
                    &nbsp;.
                  </div>

                  <div className={`${styles['ask-title']} padding-top-14`}>· What is Shippit?</div>
                  <div className={styles['answer-desc']}>
                    Shippit is Australia&apos;s leading multi-carrier shipping software. The delivery status of a package can be checked via the Internet at &nbsp;
                    <Link
                      href="https://www.shippit.com.sg/track-your-package/"
                      legacyBehavior
                    >
                      <a className={styles['link']} rel="noopener noreferrer">
                        https://www.shippit.com.sg/track-your-package/
                      </a>
                    </Link>
                    &nbsp;.
                  </div>

                  <div className={`${styles['ask-title']} padding-top-14`}>· What is CouriersPlease?</div>
                  <div className={styles['answer-desc']}>
                    CouriersPlease is a leading franchised E-Commerce and parcel delivery expert with a 40 year history of success. The delivery status of a package can be checked via the Internet at &nbsp;
                    <Link
                      href="https://www.couriersplease.com.au/tools-track"
                      legacyBehavior
                    >
                      <a className={styles['link']} rel="noopener noreferrer">
                        https://www.couriersplease.com.au/tools-track
                      </a>
                    </Link>
                    &nbsp;.
                  </div>
                </div>

                <div className={`${styles['content-title-box']} margin-top-8`}>
                  <div className={styles['content-point']}>6</div>
                  <div className={styles['title-text']}>
                    <b>Kinisi</b>
                  </div>
                </div>

                <div className={`padding-16`}>
                  <div className={styles['ask-title']}>· What is Kinisi?</div>
                  <div className={styles['answer-desc']}>
                    Kinisi mainly targets parcel delivery tasks in the surrounding areas of Melbourne and Sydney, and is often used to deliver large goods (for items exceeding 25KG). The delivery status of a package can be checked via the Internet at &nbsp;
                    <Link
                      href="https://kinisitransport.com/tracking/"
                      legacyBehavior
                    >
                      <a className={styles['link']} rel="noopener noreferrer">
                        https://kinisitransport.com/tracking/
                      </a>
                    </Link>
                    &nbsp;.
                  </div>
                </div>

                <div className={`${styles['content-title-box']} margin-top-8`}>
                  <div className={styles['content-point']}>7</div>
                  <div className={styles['title-text']}>
                    <b>Taxes/customs duties</b>
                  </div>
                </div>

                <div className={`padding-16`}>
                  <div className={styles['answer-desc']}>
                    Australia allows free trade over the Internet and will not charge any customs duty whatsoever for small packages entering the country.<br/>
                    We will endeavour to assist and cover cases where duty is charged, if you are charged customs then please collect the package, pay any fees due and then contact us and we will reimburse you.
                  </div>
                </div>

                <div className={`${styles['content-title-box']} margin-top-8`}>
                  <div className={styles['content-point']}>8</div>
                  <div className={styles['title-text']}>
                    <b>Shipping charges for multiple items</b>
                  </div>
                </div>

                <div className={`padding-16`}>
                  <div className={styles['answer-desc']}>
                    Unlike others, CrazySales would not despatch all items together for postage discounts on multiple items, as it would postpone the delivery speed and cause you inconvenience. However, even with postage costs taken into account, we are still the most competitive online seller in Australia.
                  </div>
                  <div className={`${styles['answer-desc']} padding-top-8`}>
                    Currently, each item is individually dispatched and you can track it through the delivery process from our depot to your front door which increases extra safety.
                  </div>
                  <div className={`${styles['answer-desc']} padding-top-8`}>
                    Sending items individually also allows our despatch process to be streamlined. This means that there is less processing time per order and items can also be dispatched directly from our suppliers and other locations without wasting time by consolidating before delivery.
                  </div>
                  <div className={`${styles['answer-desc']} padding-top-8`}>
                    CrazySales subsidises the postage costs for a number of items to ensure that our stock turns over quickly and that we provide our customers with the best deal. Please kindly note that the postage costs for each item include full transit insurance.
                  </div>
                </div>

                <div className={`${styles['content-title-box']} margin-top-8`}>
                  <div className={styles['content-point']}>9</div>
                  <div className={styles['title-text']}>
                    <b>Undeliverable Packages</b>
                  </div>
                </div>

                <div className={`padding-16`}>
                  <div className={styles['answer-desc']}>
                    Occasionally, packages are returned to us as undeliverable. When the freight company returns an undeliverable package to us, we will contact you via email or phone.
                  </div>
                </div>

                <div className={`${styles['content-title-box']} margin-top-8`}>
                  <div className={styles['content-point']}>10</div>
                  <div className={styles['title-text']}>
                    <b>Why are packages occasionally undeliverable?</b>
                  </div>
                </div>

                <div className={`padding-16`}>
                  <div className={styles['answer-desc']}>
                    <b>Incorrect Address.</b>Packages are normally only undeliverable when the address is incorrect. Please check your address carefully when placing your order. If this happens, a re-delivery fee will apply. In rare cases, it is also possible that the address label became illegible during the shipping and handling process, in this case, the goods will be re-shipped free of charge.
                  </div>
                  <div className={`${styles['answer-desc']} padding-top-8`}>
                    <b>Failed Delivery Attempt.</b>If you are not at home when your package arrives and it is being delivered by Post eParcel or Australian Air Express, and a card will be left in your letter box so that you can pick it up from your local Post Office. Or if your package is being delivered by Toll IPEC Management, arrangements will be made in advance to ensure that it can be delivered at a time convenient to you. If you aren&apos;t available at the agreed time, a redelivery fee may apply.
                  </div>
                  <div className={`${styles['answer-desc']} padding-top-8`}>
                    <b>Refused by Recipient.</b>If you are sending a gift, it may be a good idea to let the recipient know that a surprise is on the way, otherwise, they may refuse to accept the package, believing that it was sent to them in error.
                  </div>
                  <div className={`${styles['answer-desc']} padding-top-8`}>
                    If you suspect your order cannot be delivered as addressed and you have not received confirmation of its return to us after 4 weeks from the estimated delivery date, please contact us.
                  </div>
                  <div className={`${styles['answer-desc']} padding-top-8`}>
                    Please also note that deliveries with addresses on some farms, mine sites, islands, Aboriginal sacred sites and other regional or remote locations may not be accessible to our couriers and will not be able to be delivered to your doorsteps. In such cases, our courier will contact you for alternate delivery options.
                  </div>
                </div>
              </div>
            }
            {
              (activeTab === 2)
              &&
              <div className={styles['tab-three']}>
                <div className={styles['ask-title']}>eParcel / Fast House / Sendle</div>
                <div className={styles['answer-desc']}>
                  The package will be sent to the address you provide and if you are not at home when your delivery arrives, a card will be left in your letterbox so that you can collect your goods from your local Post Office.
                </div>

                <div className={`${styles['ask-title']} padding-top-14`}>Hunter / Hunter express</div>
                <div className={styles['answer-desc']}>
                  The package will be sent to the address you provide. All deliveries must be marked for a valid street address since Hunter will not deliver to post boxes. Please note that additional charges may apply if you require delivery on a specific date or time.
                </div>

                <div className={`${styles['ask-title']} padding-top-14`}>Aramex</div>
                <div className={styles['answer-desc']}>
                  Your package will be sent to the address you provide, and if you are not at home when your delivery arrives, a card will be left in your letterbox so that you can collect your goods from your local Post Office or the nearest depot, or you can visit &nbsp;
                  <Link
                    href="https://www.aramex.com.au/services/calling-card-left#!/Store#%2FStore"
                    legacyBehavior
                  >
                    <a className={styles['link']} rel="noopener noreferrer">
                      https://www.aramex.com.au/services/calling-card-left#!/Store#%2FStore
                    </a>
                  </Link>
                  &nbsp; to track your delivery.
                </div>

                <div className={`${styles['ask-title']} padding-top-14`}>Allied express</div>
                <div className={styles['answer-desc']}>
                  Your package will be sent to the address you provide, and if you are not at home when your delivery arrives, a card will be left in your letterbox with directions to  &nbsp;
                  <Link
                    href="https://www.alliedexpress.com.au/"
                    legacyBehavior
                  >
                    <a className={styles['link']} rel="noopener noreferrer">
                      www.alliedexpress.com.au
                    </a>
                  </Link>
                  &nbsp; . Follow the &quot;Missed a delivery?&quot; link from its homepage to track your parcel.
                </div>

                <div className={`${styles['ask-title']} padding-top-14`}>Dropshipping</div>
                <div className={styles['answer-desc']}>
                  If you wish to purchase goods in bulk to resell them (on eBay, at local markets, at small retailers, or fundraisers), CrazySales will be happy to ship these goods directly to your customers.
                </div>

                <div className={`${styles['ask-title']} padding-top-14`}>Pickups are not available</div>
                <div className={styles['answer-desc']}>
                  Unfortunately, CrazySales is unable to offer a pickup service for some reasons:<br/>
                  CrazySales ensures that you receive your goods as soon as possible by limiting its delivery mechanisms. Offering a pickup service would influence the existing streamlined logistics process and slow down delivery times for all customers.
                </div>

                <div className={`${styles['ask-title']} padding-top-14`}>Insurance</div>
                <div className={styles['answer-desc']}>
                  CrazySales incorporates the cost of insurance into its shipping charge, so there is never a concern about your goods being lost in transit. <br/>
                  If your goods do not arrive, CrazySales will resend them.
                </div>

              </div>
            }
          </div>
        </div>
      </DefaultLayout>
    </>
  )
}